import { render, staticRenderFns } from "./PriceReveal.vue?vue&type=template&id=94f0d5d6&scoped=true"
import script from "./PriceReveal.vue?vue&type=script&lang=js"
export * from "./PriceReveal.vue?vue&type=script&lang=js"
import style0 from "./PriceReveal.vue?vue&type=style&index=0&id=94f0d5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f0d5d6",
  null
  
)

export default component.exports